import { BORDER_COLOR } from "../../theme";

const styles = {
    header: {
        fontWeight: "bold",
        mt: 3
    },
    filterBox: {
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${BORDER_COLOR}`,
        textAlign: 'left',
        padding: "15px 15px 0px 15px",
        borderRadius: "8px"
    },
    loadingBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 60
    },
    matrixContainer: {
        textAlign: 'center',
        width: '100%'
    },
    dashboardContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 2,
        mt: 2,
    },
    dashboardContainerSm: {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: 2,
        mt: 2,
    },
};

export default styles;
